module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/internal/accmgr/ba/Paragraphs/paragraphs.component.css
// module id = ./client/app/internal/accmgr/ba/Paragraphs/paragraphs.component.css
// module chunks = main